import {AppContext, initApp} from './utils/app-init';
import {GrdfLeadForm} from './app/grdf-lead-form';
import {GoogleMapIntegration} from './libs/google-map-integration';
import {CallIntentButton} from './utils/call-intent-button';

initApp((context: AppContext) => {
	const form: HTMLFormElement = document.querySelector('#lead-gen-form') as HTMLFormElement;
	const formParentElement: HTMLElement = document.querySelector('.form-container') as HTMLElement;
	const map: HTMLDivElement = document.querySelector('#map') as HTMLDivElement;
	new GrdfLeadForm(form, formParentElement, context, false).initFormInputBehavior();
	new GoogleMapIntegration(map, '/assets/grdf_2022/marker.svg')
		.initMap(GoogleMapIntegration.getZoomLevel(''));
	new CallIntentButton(context).init();
});
